// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    font-family: sans-serif;
    text-align: center;
    margin-top: 50px;
  }
  
  input[type="range"] {
    -webkit-appearance: none;
    height: 8px;
    border-radius: 5px;
    background-image: linear-gradient(var(--bs-azure), var(--bs-azure));
    background-repeat: no-repeat;
    margin-top: 12px
  }
  
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: var(--bs-azure);
    cursor: pointer;
    box-shadow: 0 0 2px 0 #555;
    -webkit-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
  }
  
  input[type="range"]::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
  
  input[type="range"]::-webkit-slider-thumb:hover {
    box-shadow: var(--bs-teal)  0px 0px 0px 8px;
  }
  
  input[type="range"]::-webkit-slider-thumb:active {
    box-shadow: var(--bs-teal) 0px 0px 0px 11px;
    -webkit-transition: box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      left 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      left 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  input[type="checkbox"] {
    color: #0c4160;
    border-color: rgba(29, 37, 59, 0.5);
    border-radius: 0.4285rem;
    font-size: 0.7500000025rem;
    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    margin-top: 0.3rem;
    margin-left: -1.25rem;
    display: block;
    width: 100%;
    min-width: 9mm;
    height: calc(2.249999625rem + 2px);
    font-weight: 400;
    line-height: 1.428571;
    background-color: transparent;
    background-clip: padding-box;
    border: 1px solid #cad1d7;
    box-shadow: none;
    font-family: "Poppins", sans-serif;
    overflow: visible;
    margin: 0;
    cursor: default;
    -webkit-appearance: auto;
            appearance: auto;
  }

.col .form-control .invalid-date {
    border: 1px solid red; /* Add red border */
    background-color: #ffe6e6; /* Optional: Light red background */
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/DynamicInput.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,mEAAmE;IACnE,4BAA4B;IAC5B;EACF;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,0BAA0B;IAC1B,+CAAuC;IAAvC,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,2CAA2C;IAC3C;;mDAE+C;IAF/C;;mDAE+C;EACjD;;EAEA;IACE,cAAc;IACd,mCAAmC;IACnC,wBAAwB;IACxB,0BAA0B;IAC1B,oGAAoG;IACpG,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,wBAAgB;YAAhB,gBAAgB;EAClB;;AAEF;IACI,qBAAqB,EAAE,mBAAmB;IAC1C,yBAAyB,EAAE,mCAAmC;AAClE","sourcesContent":[".App {\n    font-family: sans-serif;\n    text-align: center;\n    margin-top: 50px;\n  }\n  \n  input[type=\"range\"] {\n    -webkit-appearance: none;\n    height: 8px;\n    border-radius: 5px;\n    background-image: linear-gradient(var(--bs-azure), var(--bs-azure));\n    background-repeat: no-repeat;\n    margin-top: 12px\n  }\n  \n  input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    background: var(--bs-azure);\n    cursor: pointer;\n    box-shadow: 0 0 2px 0 #555;\n    transition: background 0.3s ease-in-out;\n  }\n  \n  input[type=\"range\"]::-webkit-slider-runnable-track {\n    -webkit-appearance: none;\n    box-shadow: none;\n    border: none;\n    background: transparent;\n  }\n  \n  input[type=\"range\"]::-webkit-slider-thumb:hover {\n    box-shadow: var(--bs-teal)  0px 0px 0px 8px;\n  }\n  \n  input[type=\"range\"]::-webkit-slider-thumb:active {\n    box-shadow: var(--bs-teal) 0px 0px 0px 11px;\n    transition: box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n      left 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n      bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  }\n  \n  input[type=\"checkbox\"] {\n    color: #0c4160;\n    border-color: rgba(29, 37, 59, 0.5);\n    border-radius: 0.4285rem;\n    font-size: 0.7500000025rem;\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    margin-top: 0.3rem;\n    margin-left: -1.25rem;\n    display: block;\n    width: 100%;\n    min-width: 9mm;\n    height: calc(2.249999625rem + 2px);\n    font-weight: 400;\n    line-height: 1.428571;\n    background-color: transparent;\n    background-clip: padding-box;\n    border: 1px solid #cad1d7;\n    box-shadow: none;\n    font-family: \"Poppins\", sans-serif;\n    overflow: visible;\n    margin: 0;\n    cursor: default;\n    appearance: auto;\n  }\n\n.col .form-control .invalid-date {\n    border: 1px solid red; /* Add red border */\n    background-color: #ffe6e6; /* Optional: Light red background */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
